import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from "../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {ShoppingCartResponse} from "../models/shoppingCartResponse";
import {ShoppingCartRequest} from "../models/shoppingCartRequest";
import {LanguageVariations} from "../layouts/language-selector/language-uppercase.enum";

@Injectable({
  providedIn: 'root',
})
export class ShoppingCartService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {
  }

  getBucketForCurrentUser(languageCode?: string): Observable<ShoppingCartResponse> {
    const params: { [key: string]: any } = {
      languageCode: languageCode || 'EN',
    }
    return this.http.get<ShoppingCartResponse>(`${this.apiUrl}/carts/user`, {params});
  }
  
  getBucketItemsTotalForCurrentUser(languageCode?: string): Observable<number> {
    return this.http.get<number>(`${this.apiUrl}/carts/user/total`);
  }

  removeProductFromBucket(cartItemId: number): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/carts/remove/${cartItemId}`, {});
  }

  addProductToBucket(shoppingCartRequest: ShoppingCartRequest, languageCode?: string): Observable<ShoppingCartResponse> {
    const params = {
      languageCode: languageCode || LanguageVariations.EN,
    }
    return this.http.post<ShoppingCartResponse>(`${this.apiUrl}/carts`, shoppingCartRequest, {params});
  }
}
